var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.url)?[_c('pdf-viewer-ui',{attrs:{"src":_vm.url}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }